import { initReactQueryAuth } from '../providers/AuthProvider';
import { Spinner } from '@telescope/cassini-ui';
import { AuthUser, FacebookLogin } from '../types/auth';
import { LoginCredentialsDTO } from '../api/loginWithEmail';
import { RegisterCredentialsDTO } from '../api/registerWithEmail';

export const getEmailLoginPayload = (data: Record<string, any>) => {
  const { user_email, ...rest } = data;
  const payload = { user_id: user_email, user_email, ...rest };
  return payload;
};

export const getFBLoginPayload = (formData: Record<string, any>, fbLoginResponse: Record<string, any>) => {
  const resPayload = {
    user_email: fbLoginResponse.email,
    first_name: fbLoginResponse.first_name,
    last_name: fbLoginResponse.last_name,
    user_id: fbLoginResponse.id,
  } as FacebookLogin;

  const formPayload = Object.fromEntries(Object.entries(formData).filter(([_, v]) => v));
  return { ...resPayload, ...formPayload };
};

const authConfig = {
  LoaderComponent() {
    return <Spinner />;
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth<
  AuthUser | null,
  unknown,
  LoginCredentialsDTO,
  RegisterCredentialsDTO
>(authConfig);
